import gql from 'graphql-tag'

export const EventListFragment = gql`
  fragment EventListFragment on Event {
    id
    slug
    title
    city
    date
    publisher_logo
    department {
      code
    }
    type {
      image_url
      title
    }
  }
`
